/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { decLoading, incLoading } from '@app/core/ngrx/actions';
import { Actions, ofType } from '@ngrx/effects';
import { Action, ActionCreator } from '@ngrx/store';
import { Observable, merge } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';

type ActionOrType = ActionCreator | string;

const getType = (item: ActionOrType) => (typeof item === 'string' ? item : item.type);

export const handleLoading =
  (actions: { start: ActionOrType; end: Array<ActionOrType>; endAll?: boolean }[]) =>
  (source: Actions<Action>): Observable<Action> =>
    merge(
      ...actions.map((a) =>
        source.pipe(
          ofType(...a.end, a.start),
          debounceTime(500),
          filter((action) => getType(a.start) === action.type),
          map((action) => incLoading({ key: action.type })),
        ),
      ),
      ...actions.map((a) =>
        source.pipe(
          ofType(...a.end),
          map(() => {
            const key = getType(a.start);
            const force = a.endAll;
            return force ? decLoading({ key, force }) : decLoading({ key });
          }),
        ),
      ),
    );
